export class NewEntity {
    Id: string;
    Name: string;
    StreetAddress: string;
    City: string;
    State: string;
    ZipCode: string;
    Phone: string;
    Fax: string;
    Email: string;
    LicenseNumber: string;
    EntityType: string;
    ParentId: string;
    TenantId: string = "5EA8C224-B3FF-4F11-B09F-5EC0C65266EC";
}
